import React, { useEffect, useRef, useState, useCallback } from "react";
import * as echarts from "echarts";
import AshaDeployedByRegionView from "./AshaDepModal";
import { useSelector, useDispatch } from "react-redux";
import { fetchAshaDeployedByRegion } from "../../../../Store/Dashboard/DashboardActions";
import * as dashboardselector from "../../../../Store/Dashboard/DashboardSelectors";
import { useTranslation } from "react-i18next";
const AshaDeployedByRegions = ({ onBarClick }) => {
  const areaType = useSelector(dashboardselector.getGlobalAreaType);
  const role = sessionStorage.getItem("userRole");
  const currentYr = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const { t } = useTranslation();
  const [chosenMonth] = useState(months[currentMonth]);
  const [chosenYr] = useState(currentYr);
  const chartRef = useRef(null);
  const [showAshaDeployedByRegionView] = useState(false);
  const dispatch = useDispatch();
  const ashData = useSelector(dashboardselector.getAshaByRegion);
  useEffect(() => {
    dispatch(fetchAshaDeployedByRegion(chosenMonth, chosenYr));
  }, [dispatch, chosenMonth, chosenYr]);
  const drawChartCallback = useCallback(
    (myChart, data, totalCount, seriesData, legendData) => {
      const drawChart = () => {
        myChart.setOption({
          tooltip: {
            trigger: "item",
          },
          legend: {
            top: "25%",
            left: "65%",
            data: legendData,
            icon: "circle",
            itemWidth: 7,
            itemHeight: 7,
            formatter: (name) => {
              const item = seriesData.find((item) => item.name === name);
              return `${name}: ${item.value}`;
            },
          },
          series: [
            {
              name: "Asha Deployed by Regions",
              type: "pie",
              radius: ["40%", "59%"],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: 14,
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: seriesData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              color: ["#FCDBB3", "#F89F36"],
            },
            {
              name: t("total"),
              type: "pie",
              radius: ["0%", "60%"],
              center: ["50%", "50%"],
              avoidLabelOverlap: false,
              label: {
                show: true,
                position: "center",
                formatter: () => {
                  return `${t("total")}\n${totalCount}`;
                },
                fontSize: 9,
                fontWeight: "bold",
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 13,
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: data,

              itemStyle: {
                color: "transparent",
              },
            },
          ],
        });
        myChart.on("click", (params) => {
          const clickedCategory = params.data.category;
          const clickedRegion = data.find(
            (item) => item.category === clickedCategory
          );

          onBarClick(clickedRegion ? clickedRegion.category : null);
        });
      };
      drawChart(); // Call the drawChart function when the callback is executed
      return () => {};
    },
    [onBarClick, t]
  );
  const initializeChart = useCallback(
    (chartRef, ashData, onBarClick) => {
      const initializeChartLogic = () => {
        const myChart = echarts.init(chartRef.current);
        const tribalCount = ashData.tribalCount || 0;
        const nonTribalCount = ashData.nonTribalCount || 0;
        const data = [
          { category: t("Tribal"), value: tribalCount },
          { category: t("nonTribal"), value: nonTribalCount },
        ];
        const legendData = data.map((item) => item.category);
        const seriesData = data.map((item) => ({
          value: item.value,
          name: item.category,
        }));
        const totalCount = data.reduce((acc, curr) => acc + curr.value, 0);
        drawChartCallback(myChart, data, totalCount, seriesData, legendData);
        return () => {
          myChart.dispose();
        };
      };

      if (chartRef.current && ashData) {
        return initializeChartLogic();
      }
      return () => {};
    },
    [drawChartCallback, t]
  );
  useEffect(() => {
    return initializeChart(chartRef, ashData, onBarClick);
  }, [ashData, chartRef, onBarClick, initializeChart]);

  return (
    <>
      {(areaType === "Rural" || areaType === "ग्रामीण") &&
        role !== "PHC MO" && (
          <div className="flex flex-column lg:gap-1 sm:gap-2 ml-2 bg-white p-3 total-asha-detail">
            <div
              className="text-base text-blue-900 font-semibold total-asha-anm"
              style={{ whiteSpace: "nowrap" }}
            >
              {t("ASHA Deployed by region")}
            </div>
            <div className="piecontain">
              <div ref={chartRef} className="piechart" />
            </div>
            {showAshaDeployedByRegionView && <AshaDeployedByRegionView />}
          </div>
        )}
    </>
  );
};
export default AshaDeployedByRegions;
